/* RESPONSIBLE TEAM: team-proactive-support */
import { buildValidations } from 'ember-cp-validations';

export default buildValidations({});
